export const pressLogos = [
  {
    url: '',
    altText: 'The Guardian Logo',
    name: 'TheGuardianLogo',
  },
  {
    url: '',
    altText: 'Metro Logo',
    name: 'MetroLogo',
    squash: true,
  },
  {
    url: '',
    altText: 'The Independant Logo',
    name: 'TheIndependantLogo',
  },
  {
    url: '',
    altText: 'The Telegraph Logo',
    name: 'TheTelegraphLogo',
  },
  {
    url: '',
    altText: 'The Washington Post Logo',
    name: 'TheWashingtonPostLogo',
  },
  {
    url: '',
    altText: 'Mail Online',
    name: 'MailOnline',
    squash: true,
  },
  {
    url: '',
    altText: 'ArtNet.com',
    name: 'ArtNetLogo',
    squash: true,
  },
  {
    url: '',
    altText: 'Bild',
    name: 'BildLogo',
  },
  {
    url: '',
    altText: 'BBC',
    name: 'BBCLogo',
    squash: true,
  },
  {
    url: '',
    altText: 'Channel 4',
    name: 'ChannelFour',
  },
  {
    url: '',
    altText: 'Huff Post',
    name: 'HuffPost',
    squash: true,
  },
]
